/** Line icons in the design system's style (24px grid, 1.75 stroke, Lucide-like). */
const PATHS = {
  screens: "M3 3h18v18H3zM3 9h18M9 9v12",
  data: "M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
  changes: "M6 3v12M18 9v12M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6M6 15c0-4 12-2 12-6",
  workflows: "M13 2 4 14h7l-1 8 9-12h-7z",
  members: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8",
  roles: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10",
  ai: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z",
  billing: "M3 6h18v12H3zM3 10h18M7 15h3",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14M20 20l-4-4",
  plus: "M12 5v14M5 12h14",
  chev: "M6 9l6 6 6-6",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  store: "M3 9l1.5-5h15L21 9M3 9v11h18V9M3 9h18M9 20v-6h6v6",
  logout: "M9 21H5V3h4M16 17l5-5-5-5M21 12H9",
  arrow: "M5 12h14M13 6l6 6-6 6",
  close: "M6 6l12 12M18 6 6 18",
  record: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6",
  chart: "M4 20V10M10 20V4M16 20v-8M22 20H2",
  table: "M3 4h18v16H3zM3 10h18M3 15h18M9 4v16",
  cursor: "M4 3l7 17 2.5-7.5L21 10z",
  bell: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg className="ic" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
